import React, { useState, useEffect } from "react";
import Autocomplete from "react-google-autocomplete";
import { countiesValuesCompare } from "./AdditionalDataForm";
import { getLocale } from "../../i18n";
import { useForm } from "react-final-form";
import { t } from "../../i18n";

interface Place {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GoogleApiResponse {
  address_components: Place[];
  [prop: string]: any;
}

const AutocompleteAddressField = () => {
  const form = useForm();
  const [place, setPlace] = useState<null | Place[]>(null);
  const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
  const getValueBySelector = (selector: string) => {
    return place!.find((el) => el.types.includes(selector));
  };
  const locale = getLocale()

  useEffect(() => {
    if (place) {
      form.change(
        "city",
        getValueBySelector("locality")?.long_name ?? ""
      );
      form.change(
        "county",
        countiesValuesCompare(
          getValueBySelector("administrative_area_level_1")!.long_name.split(" ")[0]) ?? ""
      );
      form.change(
        "addressCountryCode",
        getValueBySelector("country")?.short_name ?? "EE"
      );
      form.change(
        "street",
        getValueBySelector("route")?.long_name ?? ""
      );
      form.change(
        "houseNumber",
        `${getValueBySelector("street_number")?.long_name ?? ""}${getValueBySelector("subpremise") ? "/" + getValueBySelector("subpremise")!.long_name : ""}`
      );
      form.change(
        "postalCode",
        getValueBySelector("postal_code")?.long_name ?? ""
      );
    }
  }, [place]);

  return (
    <>
      <Autocomplete
        apiKey={GOOGLE_API_KEY}
        className="Input-input"
        language={locale}
        onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}
        options={{
          fields: ["address_components", "formatted_address"],
          types: ["geocode", "establishment"],
          componentRestrictions: { country: "ee" },
        }}
        onPlaceSelected={(place: GoogleApiResponse) => {
          setPlace(place.address_components);
        }}
        placeholder={t("loan.additional_data.address_placeholder")}
      />
    </>
  );
};

export default AutocompleteAddressField;
